'use strict';
import angular from 'angular';
var ShippingAddressController = /** @class */ (function () {
    /*@ngInject*/
    function ShippingAddressController(Auth, $log, $scope) {
        this.$scope = $scope;
        if (this.address) {
            $log.debug('address recvd  ===>', this.address);
            this.recipientName = this.address.recipientName;
            this.isDefault = this.address.isDefault;
        }
        else {
            this.address = {};
        }
        $log.debug('ShowDefault -> ', this.showDefault);
        if (this.showDefault == 'true' || this.showDefault == true) {
            $log.debug('Going to show Default checkbox');
            this.showDefault = true;
        }
        else {
            $log.debug('Going to Hide Default checkbox');
            this.showDefault = false;
        }
        var self = this;
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            $scope.$emit('AddressDetailsChanged', self.getAddressJson());
        });
    }
    ShippingAddressController.prototype.changeRecipientName = function () {
        var self = this;
        self.$scope.$emit('AddressDetailsChanged', self.getAddressJson());
    };
    ShippingAddressController.prototype.getAddressJson = function () {
        var val = {
            recipientName: this.recipientName,
            isDefault: this.isDefault
        };
        /*
            this.recipientName = '';
            this.isDefault = false;
            this.address = {};
            this.$scope.addrForm.$setPristine();
            this.$scope.addrForm.$setUntouched();
        */
        return val;
    };
    // This is to ensure that any changes to our local credit card object don't reflect in
    // the parent object that was passed to us.
    ShippingAddressController.prototype.$onChanges = function (changes) {
        if (changes.updateForm) {
            this.updateForm = angular.copy(this.updateForm);
        }
        if (changes.createForm) {
            this.createForm = angular.copy(this.createForm);
        }
        if (changes.address) {
            this.address = angular.copy(this.address);
        }
        if (changes.showDefault) {
            this.showDefault = angular.copy(this.showDefault);
        }
    };
    return ShippingAddressController;
}());
export default ShippingAddressController;
//# sourceMappingURL=shipping-address.controller.js.map